// @flow
import $ from 'jquery'
import authenticityToken from '../shared/authenticityToken'
import { encodeUrlForBackend } from './getJson'

export default function postMultiPart(url: string, data: Object) {
  data.append('authenticity_token', authenticityToken())
  return $.ajax({
    url: encodeUrlForBackend(url),
    method: 'POST',
    dataType: 'json',
    data: data,
    contentType: false,
    processData: false
  })
}
